<template>
  <div>
    <div class="audioClassBG">
      <div class="playBack f-view-c-c">
        <audio
          v-on:play="audioPlayEvent"
          @timeupdate="updateTime"
          v-on:pause="audioPauseEvent"
          v-on:ended="audioEndedEvent"
          ref="audioPlayer"
          :src="audioList.url ? audioList.url : null"
          autobuffer
        ></audio>

        <div class="schedule" @click="leapsFn" @touchmove="test">
          <div class="currentProgress" @touchstart="volume"></div>
        </div>
      </div>


      <div class="w100 marign-t-10 f-view-r-c-s margin-t-10">
          <div ref="audioTimer" class="currentTime">00:00</div>

          <div class="totalTime">{{
            audioList.totalTime | formatFilter
          }}</div>
        </div>
      <!-- 音频的按钮 -->
      <div class="audioBtnBox">
        <div class="btnBox">
          <a class="audioPreBtn" @click="skipBackward"></a>
          <a
            :class="!isplay ? 'audioPlayBtn' : 'audioPauseBtn'"
            @click="playCurrentAudioFn"
          ></a>
          <a class="audioNextBtn" @click="skipForward"></a>
        </div>
      </div>
      <!-- 音频的按钮end -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";
//过滤器
Vue.filter("formatFilter", function (value) {
  if (!value) {
    return "00:00";
  }
  var time = Math.floor(value);
  var m = Math.floor(time / 60).toString();
  m = m.length < 2 ? "0" + m : m;
  var s = (time - parseInt(m) * 60).toString();
  s = s.length < 2 ? "0" + s : s;
  return `${m}:${s}`;
});

export default {
  data() {
    return {
      //是否正在播放中
      isplay: false,
      //上次的音频码
      lastTime: null,
      //循环的time
      timer: null,
      //滑动条按钮的x位置
      spaceX: 0,
      //音频的总时长
      // totalTime:null,
    };
  },
  props: {
    /*
     *url  -- 音频路径
     *
     */
    audioList: null,
  },
  computed: {
    // 获得播放器时间码对象
    playTimer() {
      //返回对象
      return this.$refs.audioTimer;
    },

    // 获得播放器对象
    player() {
      //返回对象
      return this.$refs.audioPlayer;
    },
  },
  activated: function () {
    var that = this;
    setTimeout(function () {
      that.totalTime = that.formatTime(
        document.querySelector("audio").duration
      );
    }, 10);
  },
  methods: {
    leapsFn(ev) {
      //获取滚动条的宽度
      var widthmax = $(".schedule").width();
      //获取滚动条上点击的x轴的位置
      var point = ev.offsetX;
      //通过点击点的位置改变当前音频的播放位置
      document.querySelector("audio").currentTime =
        (point / widthmax) * document.querySelector("audio").duration;
      if (
        document.querySelector("audio").currentTime > this.audioList.totalTime
      ) {
        document.querySelector("audio").currentTime = this.audioList.totalTime;
      }
      //更新播放时间码的显示
      this.playTimer.innerText = this.getCurrentTime(this.player.currentTime);
    },
    //播放器更新时间
    updateTime() {
      $(".currentProgress").css(
        "width",
        (document.querySelector("audio").currentTime * $(".schedule").width()) /
          document.querySelector("audio").duration
      );
    },
    //滑动条按钮的拖拽移动开始
    volume(ev) {
      this.spaceX = $(".currentProgress").offset().left;
    },
    //滑动条按钮的拖拽移动过程
    test(ev) {
      var left = ev.targetTouches[0].clientX - this.spaceX;
      left = left > $(".schedule").width() ? $(".schedule").width() : left;
      $(".currentProgress").css("width", left);
      document.querySelector("audio").currentTime =
        (left / $(".schedule").width()) *
        document.querySelector("audio").duration;
      if (
        document.querySelector("audio").currentTime > this.audioList.totalTime
      ) {
        document.querySelector("audio").currentTime = this.audioList.totalTime;
      }
      //更新播放时间码的显示
      this.playTimer.innerText = this.getCurrentTime(this.player.currentTime);
    },
    //点击按钮播放音频
    playCurrentAudioFn(ev) {
      //如果不在播放中
      if (!this.isplay) {
        this.player.play();
        this.isplay = true;
      } else {
        this.player.pause();
        this.isplay = false;
      }
    },
    //更新播放时间
    getCurrentTime(mtime) {
      var t = mtime;
      return this.formatTime(t);
    },
    //格式化时间
    formatTime(time) {
      time = Math.floor(time);
      var m = Math.floor(time / 60).toString();
      m = m.length < 2 ? "0" + m : m;

      var s = (time - parseInt(m) * 60).toString();
      s = s.length < 2 ? "0" + s : s;

      return `${m}:${s}`;
    },
    //音频播放事件
    audioPlayEvent(event) {
      // clearInterval(this.timer);
      var that = this;

      //更新播放码的时间
      this.timer = setInterval(function () {
        //更新播放时间码的显示
        that.playTimer.innerText = that.getCurrentTime(that.player.currentTime);
      }, 1000);
    },
    //音频暂停事件
    audioPauseEvent(event) {
      clearInterval(this.timer);
    },
    //音频播放完事件
    audioEndedEvent(event) {
      this.isplay = false;
    },
    skipBackward() {
      this.player.currentTime -= 15;
      if (this.player.currentTime < 0) {
        this.player.currentTime = 0;
      }
      this.playTimer.innerText = this.getCurrentTime(this.player.currentTime);
    },
    skipForward() {
      this.player.currentTime += 15;
      if (this.player.currentTime > this.audioList.totalTime) {
        this.player.currentTime = this.audioList.totalTime;
      }
      this.playTimer.innerText = this.getCurrentTime(this.player.currentTime);
    },
  },
};
</script>

<style scoped>
.audioClassBG {
  position: relative;
  width: 100%;
  margin-top: 0.15rem;
  margin-bottom: 0.15rem;
  background-size: 100% 100%;
}
.playBack {
  display: flex;
}
.playBack span {
  font-size: 0.8rem;
  color: #000;
  font-weight: bold;
  padding: 0 0.82rem;
}
.playBack .schedule {
  margin-top: 0.42rem;
  width: 16.75rem;
  height: 0.1905rem;
  opacity: 1;
  border-radius: 0.095rem;
  background: rgba(138, 138, 138, 0.24);
}
.playBack .currentProgress {
  height: 0.1905rem;
  width: 100%;
  background: linear-gradient(90deg, rgba(248, 167, 125, 1) 0%, rgba(248, 167, 125, 1) 4.92%, rgba(254, 116, 107, 1) 100%);
  position: relative;
  z-index: 201;
  border-radius: 0.095rem;
}
.playBack .currentProgress::before {
  content: "";
  height: 0.7615rem;
  width: 0.7615rem;
  display: block;
  background: rgba(249, 116, 108, 1);
  border-radius: 50%;
  position: absolute;
  right: -0.2rem;
  top: -0.2855rem;
}
.currentTime{
  opacity: 1;
  color: rgba(138, 138, 138, 1);
}
.totalTime{
  opacity: 1;
  color: rgba(138, 138, 138, 1);
}
/* 音频按钮 */
.audioBtnBox {
  margin-top: 0.3rem;
  width: 100%;
}
.audioBtnBox .btnBox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 1.88rem;
}
.audioBtnBox .audioPlayBtn {
  display: block;
  width: 3.3rem;
  height: 2.4rem;
  margin: 0 1.2rem;
  background: url("/static/images/play@3x.png") no-repeat;
  background-size: 100% 100%;
}
.audioBtnBox .audioPauseBtn {
  display: block;
  width: 3.3rem;
  height: 2.4rem;
  margin: 0 1.2rem;
  background: url("/static/images/pause@3x.png") no-repeat;
  background-size: 100% 100%;
}
.audioBtnBox .audioPreBtn {
  display: block;
  width: 1.33rem;
  height: 1.33rem;
  background: url("/static/images/audioPreBtn@3x.png") no-repeat;
  /* background: url("http://au-smart.cn/auscience/static/img/audioPreBtn.png")
    no-repeat; */
  background-size: 100% 100%;
}
.audioBtnBox .audioNextBtn {
  display: block;
  width: 1.33rem;
  height: 1.33rem;
  background: url("/static/images/audioNextBtn@3x.png") no-repeat;
  /* background: url("http://au-smart.cn/auscience/static/img/audioNextBtn.png")
    no-repeat; */
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/audio.vue